import { render } from "./Business.vue?vue&type=template&id=6be3e6db&scoped=true"
import script from "./Business.vue?vue&type=script&lang=js"
export * from "./Business.vue?vue&type=script&lang=js"

import "./Business.vue?vue&type=style&index=0&id=6be3e6db&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6be3e6db"

export default script